import React from 'react';
import DragDropArea from './DragDropArea';

export default function DocumentUploadCard({
  key,
  title,
  required = false,
  description,
  files = [],
  onFilesAdded,
  onFileDelete,
  onFileRename,
}) {
  return (
    <div className="border border-dashed rounded-2xl p-6 bg-white space-y-4">
      <h4>
        {title}{required && <span className="text-red-500"> - Required *</span>}
      </h4>

      {description && (
        <p className="text-xs text-gray-500">{description}</p>
      )}

      <DragDropArea
        key={key}
        files={files}
        onFilesAdded={onFilesAdded}
        onFileDelete={onFileDelete}
        onFileRename={onFileRename}
      />
    </div>
  );
}
